import { Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { MultiBankApi } from "../../../../shared/nestjs/gd-only/services/multibank.api";
import { NestResponsesProvider } from "../../../../shared/nestjs/nest-responses";
import { NestApiProvider } from "../../../../shared/nestjs/nest-api";
import { RequestDistributionListingDto, RequestDistributionViewEditDto, RequestSaveDistributionDto } from "../../../../shared/nestjs/gd-integrated/dto/bank-distribution-sf6.dto";
import { BankDistributionSf6Api } from "../../../../shared/nestjs/gd-integrated/services/bank-distribution-sf6.api";
import { BankAccountSf6Provider } from "../../../../shared/nestjs/gd-integrated/services/bank-account-sf6";

@Injectable()
export class ProfileBankDistributionBloc {

  subscriptions: Array<Subscription> = [];

  constructor(
    public multiBankApi: MultiBankApi,
    public nestResponse: NestResponsesProvider,
    public nestApiProvider: NestApiProvider,
    private bankDistributionSf6Api: BankDistributionSf6Api,
    private bankAccountSf6Provider: BankAccountSf6Provider,
  ) { }

  getListing(payload: RequestDistributionListingDto): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.bankDistributionSf6Api.listing(payload)
          .subscribe((result) => {
            resolve(result)
          }, error => {
            reject(error);
          })
      )
    })
  }

  getViewEdit(payload: RequestDistributionViewEditDto): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.bankDistributionSf6Api.viewEdit(payload)
          .subscribe((result) => {
            resolve(result);
          }, error => {
            reject(error);
          })
      )
    })
  }

  save(payload: RequestSaveDistributionDto): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.bankDistributionSf6Api.save(payload)
          .subscribe((result) => {
            resolve(result);
          }, error => {
            reject(error);
          })
      )
    })
  }

  dispose() {
    this.subscriptions.forEach((sub) => sub.unsubscribe);
  }

  getBankList(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.bankAccountSf6Provider.bankNameList()
          .subscribe((result) => {
            resolve(result.data);
          }, error => {
            reject(error);
          })
      )
    })
  }

  getCurrencyList(companyCode): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.bankAccountSf6Provider.currencyList({ "companyCode": companyCode })
          .subscribe((result) => {
            resolve(result.data);
          }, error => {
            reject(error);
          })
      )
    })
  }
  
}


// WEBPACK FOOTER //
// ./src/bloc/feature/profile/profile-bank-distribution/profile-bank-distribution.bloc.ts